import { useEffect } from "react";
import { useNotifications } from "../../../../context/NotificationContext";

export const NotificationButton = () => {
    const { unread, loadUnread } = useNotifications();
    useEffect(() => {
        loadUnread();
    }, [loadUnread]);

    return (
        <div className="btn position-relative p-1">
            { unread > 0 && (
                <span className="position-absolute top-0 start-0 translate-middle badge rounded-pill bg-danger">
                    { unread > 99 ? '99+': unread }
                </span>
            )}
            <i className="bi bi-bell fs-2"></i>
        </div>
    )
}